import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import type { AdItem } from '@sbt-web/network/types';
import BottomBar from '../../BottomBar';
interface BottomSectionProps {
  classes?: string[];
  item: AdItem;
}
const BottomSection: FC<BottomSectionProps> = t0 => {
  const $ = _c(9);
  const {
    classes: t1,
    item
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  let t3;
  if ($[2] !== classes) {
    t3 = classnames("detail-component", ...classes);
    $[2] = classes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== item) {
    t4 = <BottomBar item={item} />;
    $[4] = item;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <section className={t3}>{t4}</section>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default BottomSection;